module.exports = __webpack_public_path__ + "img/logo.b86f6d84.svg";